const routeConstant = {
    DEFAULT_PAGE: "/",
    LOGIN_PAGE: "/login",
    SIGNUP_PAGE: "/signup",
    VERIFY_OTP_PAGE: "/verify-otp",
    RESET_PASSWORD_PAGE: "/reset-password",
    CREATE_PASSWORD_PAGE: "/create-password",
    SELECT_SPORT_PAGE: "/select-sport",
    FORGOT_PASSWORD_PAGE: "/forgot-password",
    PAGE_NOT_FOUND: "*",
    MY_ACCOUNT_PAGE: "/my-account",
    CART_PAGE: "/cart",
    SPORT_PAGE: "/sport",
    DEPLOY_TOKEN_PAGE: "/deploy-token",
    PAYMENT_PAGE: "/payment",
    MY_CONTACT: "/contact-info",
    MY_PURCHASE: "/purchase-history",
    MY_COLLECTIBLES: "/my-collectibles",
    SCORE_GAME_PAGE: "/score-game",
    LIVE_GAME_PAGE: "/live-game",

    // Other Pages
    TERMS: "/terms",
    PRIVACY: "/privacy",
    COOKIES: "/cookies",
};

export default routeConstant;

export const REDIRECT_ON_LOGIN = routeConstant.MY_ACCOUNT_PAGE